import { render, staticRenderFns } from "./sendLog.vue?vue&type=template&id=906c22ca&scoped=true&"
import script from "./sendLog.vue?vue&type=script&lang=js&"
export * from "./sendLog.vue?vue&type=script&lang=js&"
import style0 from "./sendLog.vue?vue&type=style&index=0&id=906c22ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906c22ca",
  null
  
)

export default component.exports